import React from 'react';
import { SelectValueViewer } from 'components';
import { CustomSelectProps } from 'components/CustomSelect/CustomSelect.props';
import useMeasurementDateListOptions
  from 'pages/Waterfall/components/MeasurementDateList/useMeasurementDateListOptions';

const MeasurementDateListValueViewer = (props: CustomSelectProps) => {
  const {options} = useMeasurementDateListOptions();
  return <SelectValueViewer {...props} options={options} />
}

export default MeasurementDateListValueViewer;